import React, { useEffect, useState } from 'react';
import { Message } from 'primereact/message';
import { useSelector, useDispatch } from 'react-redux';
import { hideToast } from '../redux/Slices/toastSlice';

const OnScreenMessage = () => {
  const dispatch = useDispatch();
  const showToast = useSelector((state) => state?.toast?.showToast);
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    if (showToast?.severity && !showToast?.persistent) {
      setVisible(true);
      
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => {
        setVisible(false);
        dispatch(hideToast());
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [showToast, dispatch]);
  
  if (!visible || !showToast?.severity) return null;
  
  return (
    <div className="on-screen-message-container" style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 9999,
      maxWidth: '400px',
      padding: '10px',
      borderRadius: '4px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'white'
    }}>
      <Message 
        severity={showToast.severity} 
        text={showToast.summary}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default OnScreenMessage;
